import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// STUDENT
import StudentLayout from "./student/Studentlayout";
import Dashboard from "./student/Dashboard";
import StudentMessages from "./student/StudentMessages";

// ADMIN
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import UsersPage from "./admin/UsersPage";
import Message from "./admin/Message";
import AdminLogin from "./admin/AdminLogin";
import OfferLetter from "./admin/OfferLetter";
import ChecklistEditor from "./admin/components/ChecklistEditor";

// TEACHER
import TeacherLayout from "./Teacher/TeacherLayout";
import TeacherDashboard from "./Teacher/TeacherDashboard";
import TeacherMessages from "./Teacher/TeacherMessages";

// AGREEMENT MODULE
import AgreementForm from "./admin/components/AgreementForm";   // public form
import AgreementList from "./admin/components/AgreementList";   // admin list
import AgreementView from "./admin/components/AgreementView";   // admin detail
import AdminTermsEditor from "./admin/components/AdminTermsEditor"; // ✅ terms editor

function App() {
  return (
    // ✅ Basename set hai, iska matlab poori app /admin folder ke andar se hi manage ho rahi hai
    <Router basename="/admin">
      <Routes>

        {/* DEFAULT -> Ab ye automatic gurukrupaeducation.com/admin/admin-login par bhejega */}
        <Route path="/" element={<Navigate to="/admin-login" />} />

        {/* LOGIN -> URL: gurukrupaeducation.com/admin/admin-login */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* PUBLIC FRANCHISE AGREEMENT FORM -> URL: gurukrupaeducation.com/admin/franchise-agreement */}
        <Route path="/franchise-agreement" element={<AgreementForm />} />

        {/* STUDENT MODULE -> URL: gurukrupaeducation.com/admin/student/dashboard */}
        <Route path="/student" element={<StudentLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="messages" element={<StudentMessages />} />
        </Route>

        {/* ✅ FIXED ADMIN MODULE -> Main path "/" kiya hai taaki URL clean rahe */}
        {/* Iske andar ke saare pages ab bina takraav ke gurukrupaeducation.com/admin/... par khulenge */}
        <Route path="/" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />       {/* URL: gurukrupaeducation.com/admin/dashboard */}
          <Route path="users" element={<UsersPage />} />               {/* URL: gurukrupaeducation.com/admin/users */}
          <Route path="messages" element={<Message />} />             {/* URL: gurukrupaeducation.com/admin/messages */}
          <Route path="offer-letters" element={<OfferLetter />} />     {/* URL: gurukrupaeducation.com/admin/offer-letters */}
          <Route path="agreement-checklist" element={<ChecklistEditor />} />

          {/* Agreement management */}
          <Route path="agreements" element={<AgreementList />} />     {/* URL: gurukrupaeducation.com/admin/agreements */}
          <Route path="agreement/:id" element={<AgreementView />} />
          {/* Admin terms editor */}
          <Route path="agreement-terms" element={<AdminTermsEditor />} />
        </Route>

        {/* TEACHER MODULE -> URL: gurukrupaeducation.com/admin/teacher-dashboard */}
        <Route path="/teacher-dashboard" element={<TeacherLayout />}>
          <Route index element={<TeacherDashboard />} />
          <Route path="messages" element={<TeacherMessages />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;